export const EXPENSES = 'expenses';
export const INCOME = 'income';
export const PENDING_BILLS = 'pendingBills';
export const ON_TIME = 'onTime';
export const MOST_MONEY_GENERATED = 'mostMoneyGenerated';
export const ON_TIME_AND_MOST_MONEY_GENERATED = 'onTimeAndMostMoneyGenerated';
